import { useAppQuery } from "./useAppQuery.js";

interface UseProcessingActionsCountQueryOptions {
  onSuccess?: (shopData: { collection: any }) => void;
  onError?: (error: any) => void;
  enabled?: boolean;
}

export const useProcessingActionsCountQuery = (options: UseProcessingActionsCountQueryOptions) => {

  return useAppQuery<{ count: number }, Error>({
    url: "/api/actions/processing/count",
    reactQueryOptions: { ...options },
  });
};